import api from "./axiosConfig";
import { DisputeLetter, LetterTemplate } from "../types";

export const disputeLettersApi = {
  getTemplates: async (): Promise<LetterTemplate[]> => {
    const response = await api.get<LetterTemplate[]>("/letter-templates");
    return response.data;
  },

  generateLetter: async (
    disputeId: string,
    payload: { letterType: string; bureauTarget: string }
  ): Promise<string> => {
    const response = await api.post<{ letterContent: string }>(`/disputes/${disputeId}/generate-letter`, payload);
    return response.data.letterContent;
  },

  getLettersForDispute: async (disputeId: string): Promise<DisputeLetter[]> => {
    const response = await api.get<DisputeLetter[]>(`/disputes/${disputeId}/letters`);
    return response.data;
  },

  saveLetter: async (
    disputeId: string,
    payload: {
      letterContent: string;
      letterType: string;
      bureauTarget: string;
      markAsSent: boolean;
    }
  ): Promise<DisputeLetter> => {
    const response = await api.post<DisputeLetter>(`/disputes/${disputeId}/letters`, payload);
    return response.data;
  },
};
